export enum DataTransferMethod{
    S7Client = 1,
    S7Net = 2,
    OpcUa = 3,
    Modbus = 4,
}